import React from 'react'
import Trans from '../../../../components/Trans'

type NavigationButtonsProps = {
  showDetails: boolean
  toggleDetails: () => void
}

class NavigationButtons extends React.Component<NavigationButtonsProps> {
  toggleDetails = () => {
    if (!this.props.showDetails) {
      this.props.toggleDetails()
    }
  }

  toggleData = () => {
    if (this.props.showDetails) {
      this.props.toggleDetails()
    }
  }

  render() {
    return (
      <div className='flex flex-row'>
        <div>
          <button className={'w-full rounded-l bg-gray-300 hover:bg-gray-400 text-gray-700 px-3 py-1 font-semibold whitespace-no-wrap shadow text-xs focus:outline-none' + (this.props.showDetails ? ' bg-gray-400' : '')} onClick={this.toggleDetails}>
            <Trans>Details</Trans>
          </button>
        </div>

        <div>
          <button className={'w-full rounded-r bg-gray-300 hover:bg-gray-400 text-gray-700 px-3 py-1 font-semibold whitespace-no-wrap shadow text-xs focus:outline-none' + (!this.props.showDetails ? ' bg-gray-400' : '')} onClick={this.toggleData}>
            <Trans>Daten</Trans>
          </button>
        </div>
      </div>
    )
  }
}

export default NavigationButtons
